<template>
  <CForm class="mt-2">
    <CSelect
        :options="courseOptions"
        @update:value="onSelectCourse"
        label="Course name"
        v-if="!editForm.topic_id"
    />
    <label v-if="editForm.topic_id">Course: {{ editForm.course_name }}</label>
    <CInput label="Topic name" placeholder="Please enter the topic name" v-model="form.name"/>
    <CButton @click="cancel" class="mr-2" color="danger" size="sm">Cancel</CButton>
    <CButton :disabled="validationForm" @click="confirm" color="success" size="sm">Confirm</CButton>
  </CForm>
</template>

<script>
import {mapGetters} from "vuex"

export default {
  name: "addTopic",
  props: {
    editForm: Object
  },
  data() {
    return {
      courseOptions: [],
      form: {
        course: {
          id: 0,
          name: ""
        },
        name: ""
      }
    }
  },
  mounted() {
    if (this.editForm.topic_name !== undefined) {
      this.form.name = this.editForm.topic_name
    } else {
      this.$store.dispatch("course/onSetCourses")
    }
  },
  computed: {
    ...mapGetters({
      courses: "course/getCourses"
    }),
    validationForm() {
      if ((this.form.course.id === 0 || this.name === "") && this.editForm.topic_id === undefined) {
        return true
      } else {
        return false
      }
    }
  },
  watch: {
    courses(value) {
      this.courseOptions = [{value: "0", label: "Please select course"}]
      for (let i = 0; i < value.length; i++) {
        let body = {
          value: {
            id: value[i]._id,
            course: value[i].courseCode + ": " + value[i].name
          },
          label: value[i].courseCode + ": " + value[i].name
        }
        this.courseOptions.push(body)
      }
    }
  },
  methods: {
    cancel() {
      this.$emit("cancel")
    },
    confirm() {
      if (this.editForm.topic_id) {
        let body = {
          course_name: this.editForm.course_name,
          topic_id: this.editForm.topic_id,
          name: this.form.name
        }
        this.$emit("addTopicData", body)
      } else {
        this.$emit("addTopicData", this.form)
      }
    },
    onSelectCourse(e) {
      this.form.course = e
    },
  }
}
</script>
